/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Menu_SupportInputs */



/**
* | output |
* | --- |
* | "Support server" |
*
* @param {Marketing_Menu_SupportInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const marketing_menu_support = /** @type {((inputs?: Marketing_Menu_SupportInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Menu_SupportInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сервер поддержки")
	return /** @type {LocalizedString} */ ("Support server")
});